import React from 'react'
import Logo from './../../assets/logo.svg'

function AppLogo() {
  return (
    <div>
        <img src={Logo} alt=''/>
    </div>
  )
}

export default AppLogo